import React from 'react';

const textStyle: React.CSSProperties = {
  color: '#374151',
  fontSize: '16px',
  lineHeight: '28px',
  fontWeight: 400,
  textAlign: 'justify',
  marginBottom: '12px',
};

const h2Style: React.CSSProperties = {
  color: '#111827',
  fontSize: '24px',
  fontWeight: 700,
  marginBottom: '12px',
};

const PrivacyPolicy = () => {
  return (
    <main style={{ paddingTop: '100px', paddingBottom: '60px', background: '#fff', minHeight: '100vh' }}>
      <div style={{ maxWidth: '800px', margin: '0 auto', padding: '0 20px' }}>
        <h1 style={{ color: '#111827', fontSize: '36px', fontWeight: 700, marginBottom: '32px', textAlign: 'center' }}>
          Privacy Policy
        </h1>

        <div style={{ marginBottom: '32px' }}>
          <h2 style={h2Style}>1. Introduction</h2>
          <p style={textStyle}>
            Your privacy is essential to us. This Privacy Policy outlines the types of data
            collected by the "Udemy Summary: Harness the Power of OpenAI" extension and how this
            information is used.
          </p>
        </div>

        <div style={{ marginBottom: '32px' }}>
          <h2 style={h2Style}>2. Data Collection and Usage</h2>
          <p style={textStyle}>
            <strong style={{ color: '#111827' }}>User Prompt Data:</strong> The extension
            temporarily stores prompts provided by the user. This data is ephemeral and is cleared
            immediately after being accessed, ensuring no long-term retention.
          </p>
          <p style={textStyle}>
            <strong style={{ color: '#111827' }}>Extension Settings:</strong> The extension may
            store user preferences and settings related to its functionalities. These settings are
            stored locally on the user's device and are not transmitted or shared with any third
            parties.
          </p>
        </div>

        <div style={{ marginBottom: '32px' }}>
          <h2 style={h2Style}>3. Third-party Integrations</h2>
          <p style={textStyle}>
            The extension utilizes the ExtPay.js script for certain functionalities. Any data
            handling or interactions originating from this script adhere to its respective privacy
            policy, and users are encouraged to review it for detailed information.
          </p>
        </div>

        <div style={{ marginBottom: '32px' }}>
          <h2 style={h2Style}>4. Data Sharing</h2>
          <p style={textStyle}>
            The extension does not share any user data with external parties. All data
            interactions are contained within the extension and the user's device.
          </p>
        </div>

        <div style={{ marginBottom: '32px' }}>
          <h2 style={h2Style}>5. Host Permissions</h2>
          <p style={textStyle}>
            The extension operates on specific domains, including but not limited to{' '}
            <a
              href="https://www.udemy.com/"
              style={{ color: '#2563eb', textDecoration: 'underline' }}
              target="_blank"
              rel="noopener noreferrer"
            >
              https://www.udemy.com/*
            </a>
            . While active, it may interact with the content of these domains to provide its
            functionalities.
          </p>
        </div>

        <div style={{ marginBottom: '32px' }}>
          <h2 style={h2Style}>6. User Rights and Preferences</h2>
          <p style={textStyle}>
            Users have the right to modify or delete any data stored by the extension on their
            device. They can also adjust the extension's permissions or uninstall it entirely to
            stop any data interactions.
          </p>
        </div>

        <div style={{ marginBottom: '32px' }}>
          <h2 style={h2Style}>7. Updates to This Privacy Policy</h2>
          <p style={textStyle}>
            From time to time, we may update this Privacy Policy to reflect changes in our
            practices and services. When we post changes to this Privacy Policy, we will revise
            the "last updated" date at the top of this Privacy Policy. We recommend that you check
            our Privacy Policy regularly to inform yourself of any changes.
          </p>
        </div>

        <div style={{ marginBottom: '32px' }}>
          <h2 style={h2Style}>8. Contact Us</h2>
          <p style={textStyle}>
            If you have questions about this Privacy Policy or our data handling practices, please
            contact us.
          </p>
        </div>
      </div>
    </main>
  );
};

export default PrivacyPolicy;
